export const LEADERBOARD_POINTS_API = 'https://api.overlay.market/point-system/points/leaderboard'
export const TRADING_MINING_API = 'https://api.overlay.market/trading-mining'
